/* Hathaway Point — Email popup + SECRET DISCOUNT button (idempotent, theme-editor safe) */
(function () {
  'use strict';
  if (window.__hpPopupLoaded) return;
  window.__hpPopupLoaded = true;

  var STORAGE_KEY = 'hp_email_popup_seen_v5';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function init() {
    var root = document.querySelector('[data-hp-popup]');
    var secretBtn = document.querySelector('[data-hp-secret-btn]');
    if (!root || !secretBtn) return;

    var overlay = root.querySelector('[data-hp-popup-overlay]');
    var closeBtn = root.querySelector('[data-hp-popup-close]');
    var success = root.querySelector('[data-hp-popup-success]');
    var fields = root.querySelector('[data-hp-popup-fields]');
    var designMode = document.documentElement.classList.contains('shopify-design-mode');

    function open() {
      root.classList.add('is-open');
      secretBtn.classList.remove('is-visible');
      document.body.style.overflow = 'hidden';
      var email = root.querySelector('.hp-popup__input');
      if (email) setTimeout(function () { try { email.focus(); } catch (e) {} }, 120);
    }

    function close() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      // reveal the secret button once the popup has been dismissed
      secretBtn.classList.add('is-visible');
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    secretBtn.addEventListener('click', open);

    // copy discount code
    var copyBtn = root.querySelector('[data-hp-copy-code]');
    var codeEl = root.querySelector('[data-hp-discount-code]');
    if (copyBtn && codeEl) {
      var resetTimer;
      copyBtn.addEventListener('click', function () {
        var code = (codeEl.textContent || '').trim();
        var done = function () {
          copyBtn.innerHTML = 'Copied! <span class="arr">\u2713</span>';
          clearTimeout(resetTimer);
          resetTimer = setTimeout(function () {
            copyBtn.innerHTML = 'Copy code <span class="arr">&rarr;</span>';
          }, 2500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    }

    // open logic — popup appears IMMEDIATELY on the visitor's first page
    // view, once ever. The flag is set synchronously the moment we open, so
    // navigating to any other page can never re-trigger it.
    var posted = /[?&]customer_posted=true/.test(location.search);
    if (posted && success && fields) {
      fields.classList.add('is-hidden');
      success.classList.add('is-shown');
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      open();
      return;
    }

    if (designMode) {
      open();
      secretBtn.classList.add('is-visible');
      return;
    }

    var seen = false;
    try { seen = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}

    if (!seen) {
      // first visit ever: open full-screen right away, and set the flag
      // synchronously so it can never auto-open again (any tab, any page).
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e2) {}
      setTimeout(open, 100);
    } else {
      // returning visitor — never auto-open, but offer the secret button
      secretBtn.classList.add('is-visible');
    }
  }

  ready(init);

  // theme editor: re-init when the section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-hp-popup]')) init();
  });
})();
